// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// ** Axios Imports
import axios from "@configs/axios";

export const getProfileData = createAsyncThunk("profile/getProfileData", async () => {
  axios
    .get("/user/profile")
    .then((res) => {
      return {
        data: res.data,
      };
    })
    .catch((err) => {
      return {
        data: {},
      };
    });
});

export const ProfileSlice = createSlice({
  name: "profile",
  initialState: {
    profileData: { avatarr: null, username: "", first_name: "", last_name: "" },
    socket: "",
  },
  reducers: {
    handleProfileData: (state, action) => {
      state.profileData = { ...state.profileData, ...action.payload };
    },
    handleSocket: (state, action) => {
      state.socket = action.payload;
    },
  },
});

export const { handleProfileData } = ProfileSlice.actions;

export default ProfileSlice.reducer;
